const VIEW_PACKAGE_KEYS = {
    inspection_view: ['inspection_view'],
    ortho_view: ['ortho_view'],
    cesium_tiles_view: ['cesium_tiles_view'],
    bim_view: ['bim_view'],
    point_cloud_view: ['point_cloud_view'],
    gaussian_splat_view: ['gaussian_splat_view'],
    dtm_view: ['dtm_view'],
    dsm_view: ['dsm_view'],
    thermal_inspection_view: ['thermal_inspection_view']
};

export function resolveViewComponent(viewType) {
    return Object.prototype.hasOwnProperty.call(VIEW_PACKAGE_KEYS, viewType)
        ? viewType
        : null;
}

export function datasetPackageContainsView(
    datasetPackage,
    { uuid, type } = {}
) {
    const component = resolveViewComponent(type);
    const packageViews = datasetPackage?.views;

    if (!uuid || !component || !packageViews) {
        return false;
    }

    return (VIEW_PACKAGE_KEYS[component] || [component]).some(
        (key) => String(packageViews[key]?.uuid || '') === String(uuid)
    );
}

export function getReusableDatasetPackage(datasetPackage, view) {
    return datasetPackageContainsView(datasetPackage, view)
        ? datasetPackage
        : null;
}

export function findExistingViewerPane(viewsOnPage = [], viewUuid) {
    if (!viewUuid || !Array.isArray(viewsOnPage)) {
        return null;
    }

    return (
        viewsOnPage.find(
            (view) => String(view?.viewUUID || '') === String(viewUuid)
        ) || null
    );
}

export function findHydrationTargetIndex(viewsOnPage = [], viewItem = {}) {
    if (!Array.isArray(viewsOnPage)) {
        return -1;
    }

    return viewsOnPage.findIndex(
        (currentView) =>
            currentView?.id === viewItem.id &&
            currentView?.viewUUID === viewItem.viewUUID
    );
}

export function getViewHydrationKey(viewItem = {}) {
    return `${viewItem.id ?? ''}:${viewItem.viewUUID || ''}`;
}
